export default __webpack_public_path__ + "static/media/photo--lg--wheel-4.cf61d89f.jpg";